var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _g8, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g9, _path33, _g10, _path34, _path35, _path36, _path37, _path38, _g11, _path39, _g12, _path40, _g13, _path41, _g14, _path42, _g15, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 301,
    viewBox: "0 0 185 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 238
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H99.8475V237.078H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1329 213.546L15.8382 236.538C7.95405 238.945 0 233.002 0 224.705V12.3733C0 4.01408 8.06422 -1.93616 15.9776 0.584171L91.2723 24.5637C96.3773 26.19 99.8475 30.9606 99.8475 36.3533V201.713C99.8475 207.16 96.3086 211.966 91.1329 213.546Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9601 28.0063C62.9601 29.9321 61.8959 31.4931 60.5833 31.4931C59.2707 31.4931 58.2065 29.9321 58.2065 28.0063C58.2065 26.0806 59.2707 24.5195 60.5833 24.5195C61.8959 24.5195 62.9601 26.0806 62.9601 28.0063Z",
    fill: "#697079"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9567 29.6634C67.9567 30.8621 67.2941 31.8342 66.4771 31.8342C65.6597 31.8342 64.9971 30.8621 64.9971 29.6634C64.9971 28.4647 65.6597 27.4927 66.4771 27.4927C67.2941 27.4927 67.9567 28.4647 67.9567 29.6634Z",
    fill: "#697079"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 28.1772V204.977L98.4895 185.148V48.8593L11.0112 28.1772Z",
    fill: "#774331"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 88,
    height: 177
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 204.977L98.4895 185.148V48.8593L11.0112 28.1772V204.977Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.542 202.049H92.1683L98.7619 170.202H72.542V202.049Z",
    fill: "#0383A4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 88,
    height: 177
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 204.977L98.4895 185.148V48.8593L11.0112 28.1772V204.977Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6348 205.971H85.261L91.8547 174.124H65.6348V205.971Z",
    fill: "#B1E1F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 88,
    height: 177
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 204.977L98.4895 185.148V48.8593L11.0112 28.1772V204.977Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1138 93.899H60.74L60.6097 62.0518H41.1138V93.899Z",
    fill: "#0383A4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 88,
    height: 177
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 204.977L98.4895 185.148V48.8593L11.0112 28.1772V204.977Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.561 95.2676H75.1873L75.1146 63.4204H55.561V95.2676Z",
    fill: "#9870B1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 88,
    height: 177
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 204.977L98.4895 185.148V48.8593L11.0112 28.1772V204.977Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3916 93.7891H52.0179L51.8935 61.9419H32.3916V93.7891Z",
    fill: "#10BEF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 88,
    height: 177
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 204.977L98.4895 185.148V48.8593L11.0112 28.1772V204.977Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1265 88.7354L36.7527 91.3834V56.8882H17.1265V88.7354Z",
    fill: "#B1E1F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 88,
    height: 177
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 204.977L98.4895 185.148V48.8593L11.0112 28.1772V204.977Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.58838 84.7046H13.0379V52.8574H-6.58838V84.7046Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0054 133.818H95.6316L95.3655 101.971H76.0054V133.818Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7417 133.365H77.368L77.214 101.518H57.7417V133.365Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3838 131.953H67.0101L66.5966 100.106H47.3838V131.953Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9321 135.209H61.5584L55.9065 103.362H41.9321V135.209Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9429 132.682H40.5691L39.9776 100.835H20.9429V132.682Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31689 130.246H20.9432L20.7051 98.3989H1.31689V130.246Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.22705 131.964H17.3992L16.9858 100.117H-2.22705V131.964Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1885 171.762L91.8147 166.794L98.4084 139.915H72.1885V171.762Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3145 169.602H86.9407L93.5344 137.755H67.3145V169.602Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5732 170.522H81.1995L87.7932 138.674H61.5732V170.522Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1724 171.947H75.7986L82.3923 140.1H56.1724V171.947Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8745 170.639H70.5008L77.0945 138.792H50.8745V170.639Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8867 172.081H60.513L67.1067 140.233H40.8867V172.081Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0269 173.905H57.6531L64.2468 142.058H38.0269V173.905Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.145 170.986H51.7713L58.365 139.139H32.145V170.986Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7124 173.46H47.3387L53.9324 141.613H27.7124V173.46Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6294 176.893H36.2557L42.8493 145.046H16.6294V176.893Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03662 174.153H27.6629L34.2566 142.306H8.03662V174.153Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0463867 174.093H19.5799L26.1736 142.246H-0.0463867V174.093Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.79492 177.822H12.8313L19.425 145.975H-6.79492V177.822Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.978 202.796H81.6043L88.198 170.949H61.978V202.796Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8945 207.599H68.5208L75.1145 175.752H48.8945V207.599Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0767 210.973H61.7029L68.2966 179.125H42.0767V210.973Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3901 207.715H54.0164L60.6101 175.868H34.3901V207.715Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6729 212.235H45.2991L51.8928 180.388H25.6729V212.235Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8828 212.248H34.5091L41.1028 180.4H14.8828V212.248Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 218.51H30.1263L36.72 186.663H10.5V218.51Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.625 215.418H24.2513L30.845 183.571H4.625V215.418Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89307 217.29H21.5193L28.113 185.443H1.89307V217.29Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7.87988 216.287H11.7464L18.3401 184.44H-7.87988V216.287Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13.2256 216.112H6.40068L12.9944 184.265H-13.2256V216.112Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2461 170.913V140.412L67.1066 140.233V170.622L64.2461 170.913Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.793 138.114V168.48L93.5341 167.586V137.755L87.793 138.114Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4896 139.915L93.5347 140.225V166.487L98.4896 165.717V139.915Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3926 139.001V168.222L87.7929 167.409V138.674L82.3926 139.001Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2339 169.471V138.971L77.0944 138.792V169.18L74.2339 169.471Z",
    fill: "#EF5489"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1064 139.408V170.6L77.0941 169.067V138.792L67.1064 139.408Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0947 140.431V169.047L82.3928 168.222V140.1L77.0947 140.431Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3657 142.426V171.96L64.2467 171.045V142.058L58.3657 142.426Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2559 145.584V175.713L42.8488 174.376V145.046L34.2559 145.584Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8491 142.3V174.375L53.9322 172.668V141.613L42.8491 142.3Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9321 139.41V172.651L58.3654 171.975V139.139L53.9321 139.41Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1733 142.795V176.971L34.2561 175.755V142.306L26.1733 142.795Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0112 179.341L19.4253 178.05V145.975L11.0112 146.494V179.341Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4253 142.668V178.021L26.1734 176.971V142.246L19.4253 142.668Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5345 61.5682L98.7619 62.5164V48.3103L93.2344 47.0679L93.5345 61.5682Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4902 45.4727L86.6359 60.2697L93.5345 61.5675V47.1379L86.4902 45.4727Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0591 44.4268L82.3924 59.4374L87.6134 60.4365V45.74L82.0591 44.4268Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5889 43.1338L76.8226 58.35L82.3924 59.4378V44.5059L76.5889 43.1338Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7432 40.8037L67.1068 56.5108L76.9579 58.3955V43.2186L66.7432 40.8037Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3135 39.9941L64.2462 55.9649L67.1067 56.5121V40.891L63.3135 39.9941Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0215 38.27L56.6517 54.5052L64.2464 55.9645V40.2145L56.0215 38.27Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6343 37.2329L52.563 53.6817L58.2742 54.8219V38.8027L51.6343 37.2329Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8911 34.4561L41.9322 51.7595L53.8185 53.9688V37.7488L39.8911 34.4561Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5479 32.2461L32.3915 49.8367L42.8495 51.8695V35.1546L30.5479 32.2461Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0308 30.2329L25.0314 48.4647L33.9877 50.1744V33.0599L22.0308 30.2329Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.584 28.7095L16.8543 46.8179L26.1742 48.68V31.2131L15.584 28.7095Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2425 47.354V29.5749L10.7388 27.354V45.5046L19.2425 47.354Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7388 205.526L12.9947 205.076V184.265L10.7388 184.617V205.526Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3403 203.865L28.1128 201.669V185.443L18.3403 187.161V203.865Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9941 205.077L18.3404 203.896V184.44L12.9941 185.364V205.077Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8447 201.03L36.7197 199.719V186.663L30.8447 187.689V201.03Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1133 201.65L30.8451 201.031V183.571L28.1133 184.056V201.65Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8931 196.259L60.61 194.343V175.868L51.8931 177.367V196.259Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.103 198.705L51.8931 196.259V180.388L41.103 182.301V198.705Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7197 199.7L41.1033 198.732V180.4L36.7197 181.158V199.7Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6099 194.283L68.2966 192.54V179.125L60.6099 180.488V194.283Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1147 190.996L88.1979 188.055V170.949L75.1147 173.25V190.996Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2964 192.54L75.1144 191.036V175.752L68.2964 176.929V192.54Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7618 185.696V170.202L91.855 171.379V187.2L98.7618 185.696Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1978 188.029L91.8551 187.2V174.124L88.1978 174.772V188.029Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7618 71.241L91.855 70.1123V95.6644L98.7618 96.1707V71.241Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1978 66.7441V95.3845L91.8551 95.6637V67.3662L88.1978 66.7441Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1147 63.4204V94.3859L88.1979 95.3766V65.6277L75.1147 63.4204Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2964 64.1836V93.8668L75.1144 94.3739V65.3131L68.2964 64.1836Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6099 62.0518V93.2797L68.2966 93.8663V63.3595L60.6099 62.0518Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8931 61.9419V92.6146L60.61 93.2601V63.38L51.8931 61.9419Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.103 61.4775V91.7895L51.8931 92.6132V63.3134L41.103 61.4775Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7197 56.8882V91.455L41.1033 91.7811V57.6148L36.7197 56.8882Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3403 54.8604V90.0527L28.1128 90.7925V56.5089L18.3403 54.8604Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9941 52.853V89.645L18.3404 90.0428V53.7395L12.9941 52.853Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7388 89.493L12.9947 89.6445V54.7743L10.7388 54.437V89.493Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.412 102.249L95.3652 101.971V131.292L100.412 131.084V102.249Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5591 105.22V131.532L95.365 131.292V105.54L89.5591 105.22Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9912 102.495V131.927L89.5575 131.532V103.022L79.9912 102.495Z",
    fill: "#E565C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2144 101.518V132.042L79.9919 131.93V101.666L77.2144 101.518Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0298 103.098V132.297L77.214 132.042V103.439L71.0298 103.098Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5581 132.482L71.0301 132.297V100.353L66.5581 100.106V132.482Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9062 103.362V132.922L66.5301 132.483V103.948L55.9062 103.362Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.978 100.835V133.579L47.5625 133.266V101.253L39.978 100.835Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5112 102.127V133.848L39.977 133.58V102.484L33.5112 102.127Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7046 98.3989V134.375L33.5117 133.85V99.1009L20.7046 98.3989Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9858 100.117V134.53L20.5962 134.381V100.316L16.9858 100.117Z",
    fill: "#47C2BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9858 100.117V134.53L20.5962 134.381V100.316L16.9858 100.117Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9858 101.215L9.22168 100.787V134.851L16.9858 134.53V101.215Z",
    fill: "#B1E1F4"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0117 183.01L98.49 168.122V163.82L11.0117 177.434V183.01Z",
    fill: "#B26E4B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4895 95.2744L11.0112 88.5776V94.0128L98.4895 99.4671V95.2744Z",
    fill: "#B26E4B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4895 130.072L11.0112 133.685V139.087L98.4895 134.239V130.072Z",
    fill: "#B26E4B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0117 50.0382L98.49 65.544V61.3167L11.0117 44.5581V50.0382Z",
    fill: "#B26E4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.768 291.297L139.802 296.413C139.305 296.648 138.987 297.16 138.987 297.723V298.469H170.151L165.6 227.427L168.246 170.961C168.588 163.651 162.83 157.519 155.564 157.456L131.732 157.251C124.614 157.19 118.813 162.986 118.817 170.156L118.85 227.32L118.851 227.921L118.877 228.163L124.573 279.633C124.561 284.637 121.732 289.194 117.3 291.297L107.333 296.413C106.836 296.648 106.519 297.16 106.519 297.723V298.469H137.683L135.907 270.757L135.895 227.427L137.78 192.766H149.361L149.384 227.32L149.384 227.921L149.411 228.163L156.059 270.759L157.041 279.633C157.029 284.637 154.201 289.194 149.768 291.297Z",
    fill: "#0082A5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.297 87.4139L151.488 72.7417H139.753L138.944 90.1736C128.625 94.1735 127.244 98.3412 127.244 106.42L165.655 103.585C165.655 95.507 164.61 88.8154 152.297 87.4139Z",
    fill: "#B26E4B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.3 47.3091C125.526 51.3594 128.86 59.5377 135.183 60.1907C141.506 60.8438 139.878 52.2817 139.878 52.2817L128.3 47.3091Z",
    fill: "#5E3A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.501 53.0193C137.82 52.3293 134.478 56.2006 132.383 63.3345C132.065 64.2206 130.503 68.7287 130.871 69.7115C131.24 70.693 132.517 71.3338 133.583 71.4797C133.879 77.9132 134.257 81.2123 139.891 81.9496C145.395 82.6703 151.451 77.5386 152.495 67.2747C153.336 59.0173 151.672 53.7598 144.501 53.0193Z",
    fill: "#B26E4B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.691 63.0727C147.317 59.4694 143.78 56.2506 139.167 55.7742C137.182 55.5693 135.539 55.3327 135.539 55.3327C127.842 54.5377 128.3 47.3107 128.3 47.3107C129.928 44.9606 133.579 47.296 133.579 47.296C133.579 47.296 133.406 44.8998 135.331 45.0986C142.272 48.002 147.792 47.4169 152.272 48.8781C154.843 49.7161 156.506 52.2245 156.376 54.9425C156.173 59.1806 156.084 66.0269 152.821 73.819C152.418 74.7803 152.034 75.5033 151.67 76.0207C150.838 69.5236 144.758 76.2037 146.691 63.0727Z",
    fill: "#5E3A30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185 130.704C185 130.189 184.964 129.665 184.901 129.141C184.901 129.139 184.903 129.135 184.903 129.133C184.742 127.781 184.384 126.427 183.896 125.208C180.638 116.796 173.542 98.8385 171.533 96.7517C167.992 91.9524 160.868 88.3893 152.298 87.4141L138.85 96.447L138.944 89.3386C130.817 91.6028 125.081 95.4746 121.832 99.9783C121.598 100.22 121.373 100.477 121.165 100.753C113.719 110.577 107.266 115.975 102.503 116.365C98.149 116.724 93.0396 112.751 87.2424 107.412C80.8604 108.697 77.7377 109.835 76.2241 115.168C80.3538 125.31 91.2319 133.093 101.838 133.093C102.498 133.093 103.167 133.066 103.845 133.01C108.804 132.604 113.69 132.202 118.677 130.154V176.68H168.419C168.419 168.266 168.564 155.402 168.806 148.806C170.159 148.209 171.509 147.6 172.859 146.973C177.43 144.786 181.008 141.63 183.063 137.936C183.064 137.937 183.065 137.938 183.065 137.938C184.314 135.694 185 133.251 185 130.704Z",
    fill: "#F15961"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2425 107.412C80.8605 108.697 77.7382 109.835 76.2246 115.168C77.0227 117.129 78.0754 118.999 79.3272 120.744C81.1041 116.021 85.7112 112.426 91.4804 111.13C90.1117 110.008 88.6988 108.753 87.2425 107.412Z",
    fill: "#F6915A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2425 107.413C85.8103 106.093 84.3366 104.692 82.8211 103.251C81.7912 102.271 80.7428 101.274 79.6723 100.269C76.3233 97.1241 71.0778 97.3095 67.9551 100.682C64.8324 104.055 65.016 109.338 68.3649 112.483C69.4094 113.464 70.4321 114.437 71.4371 115.393C72.3971 116.306 73.3523 117.214 74.3055 118.109C75.8191 112.776 80.8605 108.698 87.2425 107.413Z",
    fill: "#B26E4B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.943 142.167C149.73 142.709 145.034 144.394 145.034 144.394L149.59 156.323C150.175 156.12 156.561 153.964 157.145 153.757C157.175 153.422 157.194 153.085 157.194 152.744C157.194 148.377 155.654 144.257 151.943 142.167Z",
    fill: "#F6915A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.194 144.416C142.981 144.957 141.505 145.192 141.505 145.192C141.505 145.192 138.278 144.663 135.835 147.032C134.919 147.936 134.52 148.947 134.703 149.769C131.345 152.145 134.465 163.909 145.609 157.869C146.348 157.644 147.087 157.34 147.808 156.948L147.802 156.936L149.589 156.323C150.174 156.12 150.758 155.912 151.341 155.704C151.371 155.37 151.39 155.033 151.39 154.692C151.39 150.325 148.904 146.506 145.194 144.416Z",
    fill: "#B26E4B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.031 88.1165C160.721 86.6592 159.505 85.575 158.031 85.4422L156.383 85.2935C156.05 83.7249 154.674 82.6045 153.081 82.6045H152.073L139.128 96.1575V86.2225C135.708 86.7793 135.018 90.626 135.018 90.626L139.128 96.9669C139.128 96.9669 155.259 87.3357 161.339 89.5626L161.031 88.1165Z",
    fill: "#F6915A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.034 117.256C144.805 117.256 144.62 117.069 144.62 116.839V92.9025C144.62 92.6718 144.805 92.4849 145.034 92.4849C145.263 92.4849 145.449 92.6718 145.449 92.9025V116.839C145.449 117.069 145.263 117.256 145.034 117.256Z",
    fill: "#FFCC66"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.435 109.045C137.206 109.045 137.021 108.858 137.021 108.628V93.0412C137.021 92.811 137.206 92.624 137.435 92.624C137.664 92.624 137.85 92.811 137.85 93.0412V108.628C137.85 108.858 137.664 109.045 137.435 109.045Z",
    fill: "#FFCC66"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.677 167.216V176.679H168.419C168.419 173.885 168.436 170.599 168.466 167.216H118.677Z",
    fill: "#F6915A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.041 279.632C157.029 284.635 154.2 289.192 149.768 291.295L139.801 296.411C139.305 296.647 138.986 297.158 138.986 297.721V298.468H170.151L168.921 279.263H157L157.041 279.632Z",
    fill: "#5E3A30"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.452 279.263H124.532L124.572 279.632C124.56 284.635 121.731 289.192 117.299 291.295L107.333 296.411C106.836 296.647 106.518 297.158 106.518 297.721V298.468H137.682L136.452 279.263Z",
    fill: "#5E3A30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 298,
    width: 32,
    height: 3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.518 298.033H137.813V300.259H106.518V298.033Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.669 298.033H106.518V300.26H137.813L137.669 298.033Z",
    fill: "#B26E4B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 298,
    width: 33,
    height: 3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.955 298.033H170.25V300.259H138.955V298.033Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.105 298.033H138.955V300.26H170.25L170.105 298.033Z",
    fill: "#B26E4B"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.928 279.384H162.498C159.723 281.838 161.414 284.95 163.825 284.95H169.285L168.928 279.384Z",
    fill: "#B26E4B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.46 279.384H128.784C126.01 281.838 127.7 284.95 130.112 284.95H136.817L136.46 279.384Z",
    fill: "#B26E4B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.523 270.756H156.088L157 279.264H168.92L168.523 270.756Z",
    fill: "#1B566B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.915 270.756H123.479L124.532 279.264H136.452L135.915 270.756Z",
    fill: "#1B566B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 86,
    width: 45,
    height: 59
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2178 86.9724V144.327L92.2523 144.888V86.2227L48.2178 86.9724Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2798 130.2L74.0135 134.932L79.6117 101.931L59.8065 96.3643L54.2798 130.2Z",
    fill: "#C6DBE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 86,
    width: 45,
    height: 59
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2178 86.9724V144.327L92.2523 144.888V86.2227L48.2178 86.9724Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9058 96.5215L69.592 129.921L79.3352 102.487L59.5301 96.9208L51.9058 96.5215Z",
    fill: "#F4F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 86,
    width: 45,
    height: 59
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2178 86.9724V144.327L92.2523 144.888V86.2227L48.2178 86.9724Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8237 129.92L65.7205 135.487L71.1556 101.651L51.3505 96.0845L45.8237 129.92Z",
    fill: "#C6DBE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 86,
    width: 45,
    height: 59
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2178 86.9724V144.327L92.2523 144.888V86.2227L48.2178 86.9724Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1561 101.652L65.6294 135.497L74.0849 135.148L79.6117 102.119L71.1561 101.652Z",
    fill: "#D8E5E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_8649_26011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 86,
    width: 45,
    height: 59
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2178 86.9724V144.327L92.2523 144.888V86.2227L48.2178 86.9724Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_8649_26011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8166 104.036L79.4857 103.977C75.6716 102.366 74.0715 104.856 75.6716 107.098L78.4349 111.551L81.9383 106.377L79.8166 104.036Z",
    fill: "#B26E4B"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5319 121.702C54.6468 121.14 54.9422 120.722 55.4184 120.445C55.895 120.169 56.4344 120.093 57.0366 120.218C57.6388 120.343 58.1044 120.627 58.4341 121.071C58.7622 121.515 58.8696 122.017 58.7551 122.578C58.6402 123.139 58.344 123.558 57.8682 123.834C57.3912 124.111 56.8522 124.187 56.25 124.062C55.6478 123.937 55.1819 123.652 54.8529 123.209C54.524 122.765 54.417 122.263 54.5319 121.702ZM55.7018 118.341C55.9285 117.234 56.2314 116.386 56.6109 115.797C56.9907 115.208 57.5068 114.736 58.1604 114.382C58.8135 114.027 59.3249 113.685 59.6945 113.355C60.0641 113.024 60.2974 112.624 60.3934 112.154C60.628 111.009 60.2556 110.335 59.2771 110.132C58.8253 110.039 58.4261 110.129 58.0794 110.405C57.7327 110.681 57.4934 111.102 57.3619 111.667L53.5454 110.875C53.8708 109.362 54.5867 108.279 55.6932 107.628C56.7996 106.976 58.1959 106.825 59.882 107.175C61.5611 107.524 62.7812 108.184 63.5433 109.156C64.3059 110.129 64.54 111.336 64.245 112.776C64.1163 113.405 63.875 113.952 63.5208 114.416C63.167 114.88 62.6604 115.324 62.0006 115.748L60.453 116.696C60.0112 116.975 59.6802 117.288 59.4607 117.634C59.2407 117.979 59.0642 118.438 58.9312 119.012L55.7018 118.341Z",
    fill: "#1B566B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchError);
export default __webpack_public_path__ + "static/media/SearchError.5aff83a60b58a7bc8bc9e3735cc5cb2a.svg";
export { ForwardRef as ReactComponent };